export default function (appendToBlock) {
  $('<div></div>', {
    class: 'form__item-error'
  }).appendTo(appendToBlock)
}
